export enum PanelVariantsEnum {
  DEFAULT = "default",
  PRIMARY = "primary",
  SUCCESS = "success",
  ERROR = "error",
}

export enum PanelTransparenciesEnum {
  DEFAULT = "default",
  MORE = "more",
  COMPLETE = "complete",
}

export enum PanelAlignmentsEnum {
  LEFT = "left",
  RIGHT = "right",
}

export enum PanelShadowsEnum {
  LEFT = "left",
  RIGHT = "right",
  TOP = "top",
  BOTTOM = "bottom",
}

export enum PanelBgAlignmentsEnum {
  LEFT = "left",
  RIGHT = "right",
}

export enum PanelBgRoundedEnum {
  ALL = "all",
  LEFT = "left",
  RIGHT = "right",
  TOP = "top",
  BOTTOM = "bottom",
}

export enum PanelBgColorsEnum {
  DEFAULT = "default",
  PRIMARY = "primary",
  ADMIN = "admin",
}
